module.exports = __webpack_public_path__ + "img/r-badge-bronze.1dffa62f.png";